import { useI18n } from "@/context/I18nContext";
import { Globe } from "lucide-react";
import { useState, useRef, useEffect } from "react";

/**
 * Dil seçici — Sidebar footer'ında da desktop header'da da doğru çalışsın diye
 * dropdown **yukarı** açılır (`bottom-full`), yüksek z-index'le sidebar overflow
 * clip'ini aşar, panel scroll'lanabilir (`max-h-[280px] overflow-y-auto`),
 * mobilde parmakla rahatça dokunulacak `py-2.5` tap hedefi + `min-w-[180px]`.
 * Seçim I18nContext üzerinden `tokenStorage`/`localStorage`'a persist ediliyor.
 */
export default function LanguageSwitcher({ compact = false, direction = "up" }) {
  const { lang, setLang, languages } = useI18n();
  const [open, setOpen] = useState(false);
  const ref = useRef(null);
  const current = languages.find(l => l.code === lang);

  useEffect(() => {
    const onClick = (e) => { if (ref.current && !ref.current.contains(e.target)) setOpen(false); };
    document.addEventListener("mousedown", onClick);
    return () => document.removeEventListener("mousedown", onClick);
  }, []);

  const panelDir = direction === "down"
    ? "top-full mt-1"
    : "bottom-full mb-1";

  return (
    <div ref={ref} className="relative" data-testid="lang-switcher">
      <button
        onClick={() => setOpen(!open)}
        className={`flex items-center gap-2 ${compact ? "px-2 py-1.5" : "px-3 py-2"} border border-white/10 text-xs hover:border-[--gold] transition-colors active:scale-95`}
        data-testid="lang-toggle"
        aria-haspopup="listbox"
        aria-expanded={open}
      >
        <Globe size={12} />
        <span>{current?.flag}</span>
        {!compact && <span>{current?.label}</span>}
      </button>
      {open && (
        <div
          role="listbox"
          className={`absolute ${panelDir} left-0 z-[70] min-w-[180px] max-h-[280px] overflow-y-auto border border-[--gold]/40 shadow-[0_20px_50px_-12px_rgba(212,175,55,0.4)] backdrop-blur-xl`}
          style={{ background: "linear-gradient(180deg, rgba(15,15,15,0.98), rgba(5,5,5,0.98))" }}
          data-testid="lang-panel"
        >
          {languages.map(l => (
            <button
              key={l.code}
              onClick={() => { setLang(l.code); setOpen(false); }}
              role="option"
              aria-selected={lang === l.code}
              className={`w-full text-left px-3 py-2.5 text-xs hover:bg-white/[.06] active:bg-white/[.10] flex items-center gap-2.5 transition-colors ${lang === l.code ? "bg-[--gold]/10" : ""}`}
              style={lang === l.code ? { color: "var(--gold)" } : {}}
              data-testid={`lang-${l.code}`}
            >
              <span className="text-base leading-none">{l.flag}</span>
              <span>{l.label}</span>
              {lang === l.code && <span className="ml-auto text-[--gold]">✓</span>}
            </button>
          ))}
        </div>
      )}
    </div>
  );
}
